import { createReducer } from "redux-create-reducer";

import {
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST,
  CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST,
  SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS,
  GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT,
  EXPORT_WATCH_LIST_ENTRIES_CSV,
  CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV,
  EXPORT_WATCH_LIST_ALL_ENTRIES_CSV,
  WATCH_LIST_DEACTIVATION,
  SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE,
  SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE,
} from "../types";

const initialState = {
  pageInfo: {
    count: 0,
    currentPage: 1,
    itemsPerPage: 10,
  },
  filters: {
    watchListId: "",
  },
  entries: [],
  watchListEntryByWatchList: [],
  isLoading: false,
  data: {},
  isExportLoading: false,
  isExportAllLoading: false,
};

const watchListEntriesByWatchListReducer = createReducer(initialState, {
  [SET_WATCH_LIST_ENTRY_BY_WATCH_LIST_SEARCH_FILTERS]: (
    state,
    { payload }
  ) => ({
    ...initialState,
    filters: payload,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST_COUNT.FULFILLED]: ( // TODO check loading
    state,
    { payload }
  ) => {
    // limit results to 10000 to comply with the default elastic search limit for from/size pagination
    let count = parseInt(payload.data, 10);
    return {
      ...state,
      pageInfo: {
        ...state.pageInfo,
        count: count,
      },
      isLoading: false,
    };
  },
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_WATCH_LIST_ENTRIES_BY_WATCH_LIST.FULFILLED]: (state, { payload }) => ({
    ...state,
    entries: payload.data,
    isLoading: false,
  }),
  [WATCH_LIST_DEACTIVATION.DEFAULT]: (state) => ({
    ...state,
    deactivateLoading: true,
  }),
  [WATCH_LIST_DEACTIVATION.PENDING]: (state) => ({
    ...state,
    deactivateLoading: true,
  }),
  [WATCH_LIST_DEACTIVATION.REJECTED]: (state) => ({
    ...state,
    deactivateLoading: false,
  }),
  [WATCH_LIST_DEACTIVATION.FULFILLED]: (state, { payload }) => ({
    ...state,
    deactivateLoading: false,
  }),
  [CLEAR_WATCH_LIST_ENTRIES_BY_WATCH_LIST]: () => initialState,

  [EXPORT_WATCH_LIST_ENTRIES_CSV.DEFAULT]: (state) => ({
    ...state,
    isExportLoading: true,
  }),
  [EXPORT_WATCH_LIST_ENTRIES_CSV.PENDING]: (state) => ({
    ...state,
    isExportLoading: true,
  }),
  [EXPORT_WATCH_LIST_ENTRIES_CSV.REJECTED]: (state) => ({
    ...state,
    isExportLoading: false,
  }),
  [EXPORT_WATCH_LIST_ALL_ENTRIES_CSV.DEFAULT]: (state) => ({
    ...state,
    isExportAllLoading: true,
  }),
  [EXPORT_WATCH_LIST_ALL_ENTRIES_CSV.PENDING]: (state) => ({
    ...state,
    isExportAllLoading: true,
  }),
  [EXPORT_WATCH_LIST_ALL_ENTRIES_CSV.REJECTED]: (state) => ({
    ...state,
    isExportAllLoading: false,
  }),
  [EXPORT_WATCH_LIST_ENTRIES_CSV.FULFILLED]: (state, { payload }) => {
    const fileName = payload.headers["content-disposition"]
      .split("filename=")[1]
      .split(";")[0];
    return {
      ...state,
      data: {
        fileBytes: new Blob([payload.data], { type: "text/csv" }),
        fileName,
      },
      isExportLoading: false,
    };
  },
  [EXPORT_WATCH_LIST_ALL_ENTRIES_CSV.FULFILLED]: (state, { payload }) => {
    const fileName = payload.headers["content-disposition"]
      .split("filename=")[1]
      .split(";")[0];
    return {
      ...state,
      data: {
        fileBytes: new Blob([payload.data], { type: "text/csv" }),
        fileName,
      },
      isExportAllLoading: false,
    };
  },
  [SET_ITEMS_PER_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE]: (
    state,
    { payload }
  ) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      itemsPerPage: payload,
    },
  }),
  [SET_CURRENT_PAGE_WATCHLIST_ENTRY_BY_WATCHLIST_TYPE]: (
    state,
    { payload }
  ) => ({
    ...state,
    pageInfo: {
      ...state.pageInfo,
      currentPage: payload,
    },
  }),
  [CLEAR_EXPORT_WATCH_LIST_ENTRIES_CSV]: () => initialState,
});

export default watchListEntriesByWatchListReducer;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/reducers/watchListEntriesByWatchListReducer.js